/* eslint-disable react/no-array-index-key */
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
// eslint-disable-next-line import/no-extraneous-dependencies
import Markdown from 'markdown-to-jsx'

// Store
import { actions } from 'core/store'

// Styled Elements
import { Wrapper, Container, Cursor } from './AICatalystMessage.elements'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = actions

function AICatalystMessage(props) {
  // Destructure
  const { message } = props
  const { role, content } = message

  return (
    <Wrapper role={role}>
      <Container role={role}>
        {role === 'ai' && !content && <Cursor />}
        <Markdown>{content}</Markdown>
      </Container>
    </Wrapper>
  )
}

// Default Props
AICatalystMessage.defaultProps = {
  message: {},
}

// Proptypes Validation
AICatalystMessage.propTypes = {
  message: PropTypes.shape({
    role: PropTypes.string,
    type: PropTypes.string,
    content: PropTypes.string,
  }),
}

export default connect(mapStateToProps, mapDispatchToProps)(AICatalystMessage)
